<template>
    <div class="fill-height" v-bind:style="style">
        <v-container class="fill-height">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="9" md="9" lg="7" xl="5">
                    <BuyerLoginCardSSO />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import BuyerLoginCardSSO from '../components/login/BuyerLoginCardSSO.vue';

export default {
    name: 'LoginBuyer',

    components: {
        BuyerLoginCardSSO
    },

    computed: {
        style() {
            const style = {};
            let image = null;

            switch (this.$store.state.application.providerCode) {
                case 'europeanhomes':
                    image = require('@/assets/europeanhomes/homepage.png');
                    break;
            }

            if (image !== null && !this.$vuetify.breakpoint.mobile) {
                style.backgroundImage = `url("${image}")`;
                style.backgroundSize = 'contain';
                style.backgroundPosition = 'center';
            }

            return style;
        }
    }
};
</script>
